module.exports = __webpack_public_path__ + "img/natures_most_fearsome_creature_the_squirrel.7c46e425.jpg";